import './styles.scss';
import React from 'react';
import PropTypes from 'prop-types';

function Attribution({
  author,
  title,
}) {
  return (
    <div className="attribution d-flex align-items-center">
      <div className="attribution-label">{author} {title.length > 0 && `, ${title}`}</div>
    </div>
  );
}

Attribution.propTypes = {
  author: PropTypes.string.isRequired,
  title: PropTypes.string,
};

Attribution.defaultProps = {
  title: '',
};

export default Attribution;
